export const initProjectSlider = () => {
  const projectSwiperSlider = new Swiper(".js-project-slider", {
    initialSlide: 1,
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: true,
    // loop: true,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // 1650: {
      //   slidesPerView: 4,
      // },
      // 1024: {
      //   slidesPerView: 4,
      // },
      // 850: {
      //   slidesPerView: 2,
      // },
      // 300: {
      //   slidesPerView: 1,
      // }
    }
  });
  const membersSwiperSlider = new Swiper(".js-members-slider", {
    initialSlide: 1,
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: true,
    // loop: true,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // 2000: {
      //   slidesPerView: 6,
      //   // loopedSlides: 4,
      //   // spaceBetween: 10
      // },
      // 1500: {
      //   slidesPerView: 5,
      // },
      // 1000: {
      //   slidesPerView: 4,
      // },
      // 800: {
      //   slidesPerView: 3,
      // },
      // 550: {
      //   slidesPerView: 2,
      // },
      // 300: {
      //   slidesPerView: 1,
      // }
    }
  });
  const newsroomSwiperSlider = new Swiper(".js-newsroom-slider", {
    initialSlide: 1,
    slidesPerView: 'auto',
    spaceBetween: 30,
    centeredSlides: true,
    // loop: true,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // 2000: {
      //   slidesPerView: 6,
      //   // loopedSlides: 4,
      //   // spaceBetween: 10
      // },
      // 1500: {
      //   slidesPerView: 5,
      // },
      // 1000: {
      //   slidesPerView: 4,
      // },
      // 800: {
      //   slidesPerView: 3,
      // },
      // 600: {
      //   slidesPerView: 2,
      // },
      // 300: {
      //   slidesPerView: 1,
      // }
    }
  });
  const welcomeBlockSlider = new Swiper(".js-welcome-slider", {
    effect: "fade",
    loop: true,
    // speed: 400,
    autoplay: {
      delay: 2000,
    },
    // // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },
    // Navigation arrows
    navigation: {
      nextEl: ".js-welcome-slider .custom-sw-actions__next",
      prevEl: ".js-welcome-slider .custom-sw-actions__prev",
    },
  })
};
